import classNames from 'styles/utils/classNames';

export enum RegistrationStatusEnum {
  Pending = 'PENDING',
  Registered = 'REGISTERED',
  Requested = 'REQUESTED',
}

const STATUS_CONFIG: Record<RegistrationStatusEnum, { label: string; className: string }> = {
  [RegistrationStatusEnum.Pending]: {
    label: 'Pending',
    className: 'bg-brand-yellow-100 text-brand-yellow-600',
  },
  [RegistrationStatusEnum.Registered]: {
    label: 'Registered',
    className: 'bg-brand-green-100 text-brand-green-500',
  },
  [RegistrationStatusEnum.Requested]: {
    label: 'Requested',
    className: 'bg-[#EDE9FE] text-[#6D28D9]',
  },
};

export default function RegistrationStatusBadge({
  status,
}: {
  status: RegistrationStatusEnum;
}) {
  const { label, className } = STATUS_CONFIG[status];
  return (
    <div className={classNames('rounded-xl px-3 py-1 text-sm font-medium leading-4', className)}>
      {label}
    </div>
  );
}
